let counter = 0;

export function generateId(): string {
  return `toast_${Date.now()}_${counter++}`;
}